<template>
  <div class="donate-stepup-popup">
    <div>
      <!-- HEADER -->
      <div class="popup-header">
        <div class="popup-header-logo">
          <img
            class="popup-logo"
            src="https://www.wwf.org.au/ecThemes/3/Images/WWF-RA-lockup-logo.svg"
          />
        </div>

        <div>
          <button class="popup-close-button" data-close type="button" @click="handleClose">
            <span class="popup-close-button-span">Close</span>
          </button>
        </div>
      </div>

      <div class="donate-stepup-content" ref="stepup">
        <div class="content-wrapper">
          <h3 class="donate-stepup-title">
            <span v-if="thankyouText">{{ thankyouText }}</span>
            <span>{{ title }}</span>
          </h3>
          <div class="cms-stepup-content" v-html="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepUp",

  props: {
    id: {
      type: String,
    },
    // Content
    title: {
      type: String,
    },
    content: {
      type: String,
    },
    // Donation/Petition details
    details: {
      type: Object,
    }
  },
  computed: {
    thankyouText() {
      if (this.details && this.details.amount) {
        return `${this.details.firstname} ${this.details.lastname}, thank you for your ${this.details.type} donation of $${this.details.amount}`;
      }
      return "";
    }
  },

  mounted() {
    // Attach amplitude event to hyperlink button in content
    const stepupButton = this.$refs.stepup.querySelector("a");
    try {
      $(stepupButton).click({ callback: this.handleClick }, function (e) {
        e.preventDefault();
        e.data.callback(this.href);
      });
    } catch (err) {
      console.error(err);
    }
  },

  methods: {
    handleClose() {
      this.$store.dispatch("logStepUpDeclined", this.id);
    },
    handleClick(link) {
      this.$store.dispatch("logStepUpActioned", { stepupId: this.id, link })
      .then(() => window.location.href = link);
    }
  },
};
</script>

<style scoped>
#reveal-popup-stepup .popup-header {
  z-index: 2;
}

#reveal-popup-stepup .popup-header-logo {
  height: 120px;
  padding: unset;
}

.wwf-popup img.popup-logo {
  width: unset;
}

#reveal-popup-stepup .donate-stepup-title {
  padding: 0;
}

.donate-stepup-content h3::before {
  content: none;
}

.donate-stepup-title span {
  display: block;
  margin-bottom: 1rem;
}

.content-wrapper {
  max-width: 440px;
  margin: 0 auto;
}

.cms-stepup-content >>> a {
  display: block;
  margin: 2rem 0;
  padding: 0.8rem;
  font-weight: bold;
  color: var(--wwfWhite);
  text-align: center;
  text-transform: uppercase;
  background: var(--wwfOrange);
  border-radius: 3px;
}

.cms-stepup-content >>> p {
  margin-bottom: 1rem;
}
</style>


// WEBPACK FOOTER //
// StepUp.vue?67755403